import { render, staticRenderFns } from "./PackagePage.vue?vue&type=template&id=6e98fd6e&scoped=true"
import script from "./PackagePage.vue?vue&type=script&lang=js"
export * from "./PackagePage.vue?vue&type=script&lang=js"
import style0 from "./PackagePage.vue?vue&type=style&index=0&id=6e98fd6e&prod&scoped=true&lang=css"
import style1 from "./PackagePage.vue?vue&type=style&index=1&id=6e98fd6e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e98fd6e",
  null
  
)

export default component.exports